import {crmApi} from 'sources/api';
import urlWithParams from 'utils/urlWithParams';
import cancelIfSending from 'sources/cancelIfSending';
import {List} from 'immutable';
import CrmOpportunity from 'records/CrmOpportunity';
import CrmStage from 'records/CrmStage';

const CrmOpportunitySource = cancelIfSending({
  searchOpportunities(term, cancelConfig) {
    const url = urlWithParams('/search/opportunities', {term});
    return crmApi
      .get(url, cancelConfig)
      .then(({data: entities}) => List(entities).map(entity => new CrmOpportunity(entity)));
  },

  fetchOpportunity(opportunityId) {
    return crmApi
      .getJson(`/opportunities/${opportunityId}`)
      .then(opportunity => new CrmOpportunity(opportunity));
  },

  fetchStages() {
    return crmApi.get('search/stages').then(resp => {
      return List(resp.data).map(data => {
        return new CrmStage({...data.first, crmName: data.second});
      });
    });
  },
});

export default CrmOpportunitySource;
